import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormGroup, FormText, Label } from 'reactstrap';

// NOTE: Unable to import directly from "../../../_forms" due to circular dependencies
import Input from '../../../_forms/components/FormInput/Input';
import { Button, DangerAlert } from '../../../_shared';
import { messages } from '../../../_shared/i18n/messages';

import { MUX_VIDEO_MASTER_ACCESS, MUX_VIDEO_MASTER_STATUS } from '../../constants';
import videoTypes from '../../types';
import { updateMasterAccess } from '../../utils';

const propTypes = {

	/**
	 * The video
	 */
	video: videoTypes.video

};

/**
 * The master access form field for a Mux video. Returns the master
 * access URL, the status update, or a button to request access
 * depending on the status.
 *
 * @param {Object} props  The component props.
 * @returns {Object}      The component.
 */
const MasterAccessField = (props) => {

	const { video } = props;

	const intl = useIntl();

	const [masterData, setMasterData] = useState(video?.master || {});
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		setMasterData(video?.master || {});
	}, [video?.master]);

	const requestMasterAccess = async () => {

		setHasError(false);

		try {

			// Send patch request to video route to update status
			const { data } = await updateMasterAccess({
				id: video.id,
				provider: video.provider,
				master_access: MUX_VIDEO_MASTER_ACCESS.TEMPORARY,
				scope: video.scope,
				scope_id: video.scope_id
			});

			setMasterData(data.master);

		} catch (error) {
			console.error(error);
			setHasError(true);
		}

	};

	return (
		<FormGroup
			className="tc-form-field"
			tag="div">
			<Label
				for="tc-live-stream-video-master-url-field"
				className="w-100">
				<FormattedMessage {...messages.TC_COMPONENTS_FORM_FORM_FIELD_MASTER_ACCESS_LABEL} />
			</Label>
			<FormText
				className="tc-form-field-help-text w-100"
				aria-live="assertive"
				tag="div">
				<FormattedMessage {...messages.TC_COMPONENTS_FORM_FORM_FIELD_MASTER_ACCESS_HELP} />
			</FormText>
			{hasError &&
				<DangerAlert>
					<FormattedMessage {...messages.TC_COMPONENTS_VIDEO_INPUT_MASTER_ACCESS_ERROR} />
				</DangerAlert>
			}
			{masterData.status === MUX_VIDEO_MASTER_STATUS.PREPARING &&
				<span id="tc-live-stream-video-master-url-field">
					<FormattedMessage {...messages.TC_COMPONENTS_FORM_FIELD_MASTER_STATUS_PREPARING} />
				</span>
			}
			{masterData.status === MUX_VIDEO_MASTER_STATUS.READY &&
				<Input
					id="tc-live-stream-video-master-url-field"
					type="text"
					name="url"
					label={intl.formatMessage(messages.TC_COMPONENTS_FORM_FORM_FIELD_MASTER_ACCESS_LABEL)}
					value={masterData.url}
					isCopyable />
			}
			{(!masterData.status || masterData.status === MUX_VIDEO_MASTER_STATUS.ERRORED) &&
				<Button
					color="neutral"
					disabled={!video}
					outline
					onClick={requestMasterAccess}>
					<FormattedMessage {...messages.TC_COMPONENTS_FORM_FORM_FIELD_MASTER_ACCESS_BUTTON} />
				</Button>
			}
		</FormGroup>
	);

};

MasterAccessField.propTypes = propTypes;

export default MasterAccessField;
